import { WIZARD_PRODUCT_CREATED, WIZARD_PRODUCT_UPDATED, WIZARD_PRODUCT_COMPLETED, WIZARD_PRODUCT_SKIP_COMPLETED, WIZARD_PRODUCT_MOVE_COMPLETED } from "./wizard.actions";
import * as _ from 'lodash';

export const wizard = (state = { status: "" }, action) => {
  switch (action.type) {
    case WIZARD_PRODUCT_CREATED:
      return _.assign({}, state, { status: "created", product: action.data });
    case WIZARD_PRODUCT_UPDATED:
      return _.assign({}, state, { status: "updated", product: action.data });
    case WIZARD_PRODUCT_COMPLETED:
      return _.assign({}, state, { status: "", product: null });
    case WIZARD_PRODUCT_SKIP_COMPLETED:
      return _.assign({}, state, { status: "", product: null });
    case WIZARD_PRODUCT_MOVE_COMPLETED:
      return _.assign({}, state, { status: "", product: null });
    default:
      return state;
  }
}
